import { INIT_PAGE_DATA } from '../../actions/modules/ModulesActionsTopic';

/**
 * 初始化STATE
 */
export const initialState: any = {
	// 用户id
	userId: '',
	// 话题基本数据
	topicInfo: {},
	// 直播间数据
	liveInfo: {
		followNum: 0,
		topicNun: 0,
	},
	evaluation: {
		evaluateNum: 0,
		score: 0,
	},
	// 话题介绍
	profile: [],

	// --- 优惠券所需数据
	// 话题优惠券列表
	topicCouponList: [],
	// 专栏优惠券列表
	channelCouponList: [],
	// 当前选中的话题优惠券
	curTopicCoupon: null,
	// 当前选中的专栏优惠券
	curChannelCoupon: null,
	// 选中的专栏票价
	curChargeConfig: null,
	// 当前选中的优惠券
	curCoupon: null,

	// 分销课代表关系
	myShareQualify: {},

	// 珊瑚计划分销身份
	coral: {},
	// 权限
	power: {},

	// --- 咨询留言数据
	// 咨询留言列表
	consultList: [],
	consultPage: 0,
	consultSize: 20,
	consultNoMore: false,
	consultStatus: '', // pending|success|end

	// 转播信息
	relayConfig: {
		// 是否转播
		isRelay: 'N',
		// 分成比例
		profitRatio: 0,
		// 是否想显示转播
		showWelcome: 'N',
	},
	// 优惠券下标
	selIdx: 0,
	// 分享榜列表
	shareList: [],
};

/**
 * topic
 */
function topic(state: any = initialState, action: any): any {
	const { type, item } = action;

	switch (type) {
		case INIT_PAGE_DATA:
			return {
				...state,
				...action.pageData,
			};
		default: {
			return state;
		}
	}
}

export default topic;
